import script from "./ApprovalUnit.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalUnit.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalUnit.vue?vue&type=style&index=0&id=ca99eb08&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca99eb08"]])

export default __exports__